//imports
import {
    UNSUBSCRIBED_CONTACT_CREATE_REQUEST,
    UNSUBSCRIBED_CONTACT_CREATE_RESULT,
    UNSUBSCRIBED_CONTACT_CREATE_OPEN_MODAL,
    UNSUBSCRIBED_CONTACT_CREATE_CLOSE_MODAL,
} from 'Redux/actionTypes';


export const createUnsubscribedContactOpenModal = (id) => ({
    type: UNSUBSCRIBED_CONTACT_CREATE_OPEN_MODAL,
    payload: { id },
});

export const createUnsubscribedContactCloseModal = () => ({
    type: UNSUBSCRIBED_CONTACT_CREATE_CLOSE_MODAL
});

export const createUnsubscribedContactRequest = (data) => ({
    type: UNSUBSCRIBED_CONTACT_CREATE_REQUEST,
    payload: data,
});

export const createUnsubscribedContactResult = (result) => ({
    type: UNSUBSCRIBED_CONTACT_CREATE_RESULT,
    payload: result
});
